import { useAuth } from '../../../hooks/useAuth';
import { useUserProfile } from '../../../hooks/useUserProfile';
import { usePostHogFeatureFlag } from '../../../hooks/usePostHogFeatureFlag';
import { Charger } from '../charger.component';
import { AcceptTerms } from '../../user-requirements/accept-terms.component';
import { AddPhone } from '../../user-requirements/add-phone.component';

/**
 * Wrapper component that gates the Charger component based on user requirements.
 * For logged-in users, ensures they have acceptedDriverTerms (default version "1.0").
 * For logged-in users, ensures they have a verified phone number.
 * Non-logged-in users can view the charger normally.
 */
export const ChargerWrapper = () => {
  const auth = useAuth();
  const { hasAcceptedDriverTerms, hasVerifiedPhoneNumber } = useUserProfile();
  const enforcePhoneNumberCollection = usePostHogFeatureFlag(
    'enforce-phone-number-collection',
    false,
  );

  // If logged in, enforce user requirements
  if (auth.isLoggedIn) {
    // If user has not accepted terms, show component to accept terms
    if (!hasAcceptedDriverTerms()) {
      return <AcceptTerms />;
    }

    // If feature flag is enabled and user has not verified phone, show component to add phone
    if (enforcePhoneNumberCollection && !hasVerifiedPhoneNumber()) {
      return <AddPhone />;
    }
  }

  // Else show charger
  return <Charger />;
};
